import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "styled-components";
import { QueryClientProvider } from "react-query";
import { store } from "app/store";
import { Provider } from 'react-redux';

import App from "App";

import { Suspense } from "components/UI/Loaders/Suspense";

import { GlobalStyle } from "styles/global";
import defaultTheme from "styles/themes/default";
import { AppContext } from "hooks";

import "reflect-metadata";

import "./styles/global.css";
import { queryClient } from "services/hooks/queryClient";

import { MantineProvider } from '@mantine/core';

import '@mantine/core/styles.css';

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <React.Suspense fallback={<Suspense />}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <AppContext>
            <MantineProvider>
              <ThemeProvider theme={defaultTheme}>
                <GlobalStyle />
                <App />
              </ThemeProvider>
            </MantineProvider>
          </AppContext>
        </QueryClientProvider>
      </Provider>
    </React.Suspense>
  </React.StrictMode>
);
